import {React,useEffect} from "react";
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";
import HeaderGuest from "../../components/layout/HeaderGuest";
import FooterOne from "../../components/layout/FooterOne";
import BottomFooter from "../../components/layout/BottomFooter";

import AdminLogin from "../../components/seller-registration/adminregistration/Login";


const AdminLoginPage = () => {
  useEffect(() => {
    document.title = "iWant Seller Login";
  }, []);

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color='#990A02' />

      {/* Preloader */}
      <Preloader />

      <HeaderGuest />

      <AdminLogin />

    </>
  );
};

export default AdminLoginPage;